var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotesToFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 7h14c.55 0 1 .508 1 1.07v10.978c0 .562-.45.952-1 .952h-1v2.376c0 .564-.404.659-.902.415L14.72 20H8c-.55 0-1-.39-1-.952V8.07C7 7.508 7.45 7 8 7"
})));
export default SvgNotesToFilled;